import { Pipe, PipeTransform } from '@angular/core';
import { MeterProperties } from '../models/meter-type';
import { MeterType } from '@lib-ui/client';

@Pipe({
  name: 'meterType',
  standalone: true,
})
export class MeterTypePipe implements PipeTransform {
  transform(typeId: MeterType | number | string | null | undefined): string {
    if (!typeId) {
      return '';
    }
    const property = MeterProperties.get(Number(typeId));
    return property?.displayName ?? '';
  }
}
